module.exports = __webpack_public_path__ + "media/components/guide-page/static/icon-wetsuit--boardshorts-75183043a97c535400d20a02e00b9fce.svg";